import * as React from "react";
import CollapsibleSidebar from "./CollapsibleSidebar";
import { CollapsibleSideContent } from "./CollapsibleSideContent";
import { Link } from "react-router-dom";
import {
  InstructorSidebarContent,
  userSidebarContent,
  userSidebarNested,
} from "@/lib/utils";
import { HRSidebarContent, HRSidebarNested } from "@/lib/utils";
import { AdminSidebarContent } from "@/lib/utils";

import logo from "../assets/logo.png";

import {
  Sidebar,
  SidebarContent,
  SidebarGroup,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from "@/components/ui/sidebar";
import { useSelector } from "react-redux";
import { RootState } from "@/types";
import { SidebarItem, SidebarNestedSection } from "@/types";

export function AppSidebar() {
  const { user } = useSelector((state: RootState) => state.user);

  let AsideContent: SidebarItem[] = [];
  let NestedSidebar: SidebarNestedSection[] = [];

  if (user?.role === "student") {
    AsideContent = userSidebarContent;
    NestedSidebar = userSidebarNested;
  }

  if (user?.role === "hr") {
    AsideContent = HRSidebarContent;
    NestedSidebar = HRSidebarNested;
  }

  if (user?.role === "admin") {
    AsideContent = AdminSidebarContent;
  }
  if (user?.role === "Instructor") {
    AsideContent = InstructorSidebarContent;
  }


  return (
    <Sidebar>
      <SidebarContent>
        <SidebarGroup>
          <Link to={"/"}>
            <img src={logo} alt="logo" className="h-12 w-36 m-5 ml-2" />
          </Link>
          <SidebarMenu className="space-y-2">
            {/* Map over userSidebarContent */}
            {AsideContent.map((item, index) => (
              <SidebarMenuItem key={index} className="pl-1">
                <SidebarMenuButton asChild>
                  <Link
                    to={item.link}
                    className="flex items-center gap-2 text-foreground"
                  >
                    <item.Icon />
                    <span className="text-lg font-medium">{item.title}</span>
                  </Link>
                </SidebarMenuButton>
              </SidebarMenuItem>
            ))}
          </SidebarMenu>

          {NestedSidebar.map((section) => (
            <CollapsibleSidebar
              key={section.header}
              h={section.header}
              Icon={section.icon}
            >
              {section.items.map((item) => (
                <CollapsibleSideContent
                  key={item.href}
                  href={item.href}
                  text={item.text}
                  Icon={item.icon}
                />
              ))}
            </CollapsibleSidebar>
          ))}
        </SidebarGroup>
      </SidebarContent>
    </Sidebar>
  );
}
